import { getReq, postReq, putReq } from "../ApiHelpers";

export const obtainCommunities = (
  searchText?: string,
  identityId?: string,
  role?: "admin" | "member",
) => {
  // leveraging the URL library with a temporary base
  var searchParams = new URLSearchParams();
  if (searchText) {
    searchParams.append("name", searchText);
  }
  if (identityId) {
    searchParams.append("identityId", identityId);
  }
  if (role) {
    searchParams.append("role", role);
  }
  return getReq(`/communities?${searchParams}`, undefined, true);
};

export interface NftType {
  name: string;
  nftTypeId: string;
  previewAssetUrl: string;
  isVideo?: boolean;
}

export const getNftTypes = (communityId?: string): Promise<NftType[]> => {
  const id = communityId || "kudos";
  return getReq(`/communities/${id}/nftTypes`, undefined, true);
};

export const getCommunityTokens = (
  communityId: string,
  isHidden: boolean = false,
  offset: number = 0,
  limit: number = defaultPageLimit,
) => {
  return getReq(
    `/communities/${communityId}/tokens?isHidden=${isHidden}&offset=${offset}&limit=${limit}`,
    undefined,
    false,
  );
};

export const getCommunity = (communityId: string) => {
  return getReq(`/communities/${communityId}`, undefined, false);
};

export const getCommunityAdmins = (communityId: string) => {
  return getReq(`/communities/${communityId}/members?role=admin`);
};

export const getCommunityMembers = (
  communityId: string,
  offset: number = 0,
  limit: number = defaultPageLimit,
  role?: string,
) => {
  let url = `/communities/${communityId}/members?offset=${offset}&limit=${limit}`;
  if (!!role) {
    url = url + `&role=${role}`;
  }

  return getReq(url, undefined, false);
};

export const getCommunityByDisplayId = (communityDisplayId: string) => {
  return getReq(
    `/communities/?displayId=${communityDisplayId}`,
    undefined,
    false,
  );
};

interface AddCommunityRolesParams {
  roles: {
    role: string;
    address: string;
  }[];
}

export const addCommunityRoles = (
  communityId: string,
  params: AddCommunityRolesParams,
) => {
  return postReq(
    `/communities/${communityId}/roles`,
    params,
    undefined,
    true,
    true,
  );
};

export const hideOrUnhideCommunityToken = (
  communityId: string,
  tokenId: string,
  isHidden: boolean,
) => {
  return putReq(
    `/communities/${communityId}/tokens/${tokenId}`,
    { isHidden },
    undefined,
    true,
  );
};

const defaultPageLimit = 50;
